<input type="time" [min]="_timeFormat(_min)" [max]="_timeFormat(_max)" [value]="_timeFormat(time)"
    (change)="_onTimeChange($event)" class="form-control">